export const geometries = [
  {
    name: "The Region",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmin: -7643346.9186,
      ymin: 1270287.8638,
      xmax: -6077916.5793,
      ymax: 2088469.8146,
    },
  },
  {
    name: "Eastern Caribbean",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmin: -7643346.9186,
      ymin: 1270287.8638,
      xmax: -6077916.5793,
      ymax: 2088469.8146,
    },
  },
  {
    name: "CROP Countries",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmin: -7643346.9186,
      ymin: 1270287.8638,
      xmax: -6077916.5793,
      ymax: 2088469.8146,
    },
  },
  {
    name: "Anguilla",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -7003675.12262372,
      xmin: -7031459.982405345,
      ymax: 2071480.2620170773,
      ymin: 2054625.8972802185,
    },
  },
  {
    name: "Antigua And Barbuda",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6753509.156765197,
      xmin: -6975788.0350183835,
      ymax: 2019877.1245298728,
      ymin: 1885042.2066348868,
    },
  },
  {
    name: "Barbados",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6600782.994124821,
      xmin: -6656352.713688069,
      ymax: 1497190.7044159593,
      ymin: 1463481.9749422418,
    },
  },
  {
    name: "Dominica",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6795728.187173981,
      xmin: -6851297.906737229,
      ymax: 1754476.7964614322,
      ymin: 1720768.0669877147,
    },
  },
  {
    name: "Grenada",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6795887.959420424,
      xmin: -6907027.398547113,
      ymax: 1406842.9632957526,
      ymin: 1339425.5043482012,
    },
  },
  {
    name: "Guadeloupe",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6783441.893355892,
      xmin: -6894581.332482581,
      ymax: 1860438.9748435349,
      ymin: 1793021.5158959834,
    },
  },
  {
    name: "Martinique",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6728251.512404165,
      xmin: -6839390.951530854,
      ymax: 1680304.104847019,
      ymin: 1612886.6458994676,
    },
  },
  {
    name: "Montserrat",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6908378.59050163,
      xmin: -6936163.4502832545,
      ymax: 1899442.124695908,
      ymin: 1882587.7599590493,
    },
  },
  {
    name: "Saba",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -7035765.932527297,
      xmin: -7042712.147472703,
      ymax: 1996488.7105921074,
      ymin: 1992275.1194078927,
    },
  },
  {
    name: "Saint Barthelemy",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6986632.843124676,
      xmin: -7000525.273015487,
      ymax: 2031144.5534415871,
      ymin: 2022717.3710731578,
    },
  },
  {
    name: "Saint Martin",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -7004027.736757134,
      xmin: -7031812.596538759,
      ymax: 2053583.6638318324,
      ymin: 2036729.2990949736,
    },
  },
  {
    name: "Saint Kitts and Nevis",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6946242.754418616,
      xmin: -7001812.473981864,
      ymax: 1968520.0233336226,
      ymin: 1934811.293859905,
    },
  },
  {
    name: "Saint Lucia",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6729583.4497719575,
      xmin: -6840722.888898646,
      ymax: 1596309.4058333538,
      ymin: 1528891.9468858023,
    },
  },
  {
    name: "Saint Vincent and the Grenadines",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -6747284.69,
      xmin: -6896184.02,
      ymax: 1525955.62,
      ymin: 1386381.60,
    },
  },
  {
    name: "Sint Eustatius",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -7003472.535850524,
      xmin: -7017364.965741335,
      ymax: 1982652.424980191,
      ymin: 1974225.2426117617,
    },
  },
  {
    name: "Sint Maarten",
    extent: {
      spatialReference: {
        wkid: 3857,
      },
      xmax: -7003932.190471778,
      xmin: -7031717.050253402,
      ymax: 2054156.9415439703,
      ymin: 2037302.5768071115,
    },
  },
];
export default geometries;
